<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>ĐẶT HẠN CHẤM ĐIỂM THI</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-flex">
                Xin vui lòng chọn hạn chấm thi:
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Ngày"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      class="pl-2"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="openConfirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeConfirm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            <span style="color: red"
              ><strong><i>(*)Lưu ý: </i></strong></span
            >Thao tác này sẽ đặt hạn ngày cuối chấm thi cho các phòng và môn này.<br />
            Bạn có chắc là bạn muốn thực hiện thao tác không?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="closeConfirm" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    data: Object,
    state: Boolean
  },
  components: {},
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    },
    data: {
      immediate: true,
      handler(newVal) {
        this.setDefaultValues(newVal)
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      date: '',
      menu: false
    }
  },
  methods: {
    ...mapActions('roomSubject', ['updateRoomSubject']),
    cancel() {
      this.$emit('closeDialog')
    },
    openConfirm() {
      this.confirmDialog = true
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidCodes = ''
    },
    async confirm() {
      this.$loading.active = true
      let dateObj = new Date(this.date)

      dateObj.setHours(23, 59, 59)

      let isoDate = dateObj.toISOString()

      const data = {
        endDate: isoDate
      }
      const indexing = await this.updateRoomSubject({ id: this.data.id, ...data })
      if (indexing) {
        this.$alert.success('Đặt hạn chấm thi thành công')
        this.$emit('refresh')
        this.closeConfirm()
        this.cancel()
      } else {
        this.$alert.error('Lỗi đánh số túi')
        this.closeConfirm()
      }
      this.$loading.active = false
    },
    setDefaultValues(data) {
      if (data) {
        this.date = data.date || ''
      }
    }
  }
}
</script>
